/**
 * Updates a URL object's search parameters by merging in the new parameters.
 *
 * This function updates the URL's searchParams: for each key in the newParams,
 * it adds or updates the URL's search parameters, preserving any existing ones.
 *
 * @param url - The URL object to update.
 * @param newParams - A URLSearchParams object containing the new parameters.
 * @returns The updated URL object.
 */
export default function updateURLSearchParams(
	url: URL,
	newParams: URLSearchParams,
): URL {
	for (const key of newParams.keys()) {
		// Remove the existing entries in url for that key
		url.searchParams.delete(key);

		const values = newParams.getAll(key);
		for (const value of values) {
			url.searchParams.append(key, value);
		}
	}
	return url;
}
